import { useEffect, useState } from 'react';
import '../styles/Footer.css';

const CYCLE_WORDS = ['Crypto', 'XRP', 'RLUSD'];

const FOOTER_COLUMNS = [
  {
    heading: 'Doppler Vaults',
    links: [
      { label: 'XRP Vault', href: 'https://app.doppler.finance/vaults/xrp' },
      { label: 'RLUSD Vault', href: 'https://app.doppler.finance/vaults/rlusd' },
    ],
  },
  {
    heading: 'Institutions',
    links: [
      { label: 'Institutional Vault', href: 'https://doppler.finance/#/institutional' },
      { label: 'Yield-as-a-service', href: 'https://doppler.finance/#/yield' },
    ],
  },
  {
    heading: 'Resources',
    links: [{ label: 'Docs', href: 'https://docs.doppler.finance/' }],
  },
  {
    heading: 'Community',
    links: [
      { label: 'X (Twitter)', href: 'https://x.com/doppler_fi' },
      { label: 'Discord', href: 'https://discord.com/invite/' },
      { label: 'Telegram', href: 'https://t.me/doppler_finance' },
      { label: 'Blog', href: 'https://blog.doppler.finance/' },
    ],
  },
];

export default function Footer({ zIndex }) {
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    // Cycle every 2.2s — noticeable but unhurried, matches
    // "changing itself but not very fast" and loops forever.
    const interval = setInterval(() => {
      setWordIndex((i) => (i + 1) % CYCLE_WORDS.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="site-footer" style={{ zIndex }}>
      {/* ---- CTA banner with video background ---- */}
      <section className="footer-cta">
        <video
          className="footer-cta__bg"
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
        >
          <source src="/images/footer-bg.webm" type="video/mp4" />
        </video>

        <div className="footer-cta__content">
          <h2 className="footer-cta__heading">
            <span className="footer-cta__muted">Earn</span>
            <span key={wordIndex} className="footer-cta__word">
              {CYCLE_WORDS[wordIndex]}
            </span>
            <span className="footer-cta__muted">effortlessly.</span>
          </h2>
          <a
            href="https://app.doppler.finance/vaults"
            target="_blank"
            rel="noreferrer"
            className="footer-cta__button"
          >
            Earn Now <span>↗</span>
          </a>
        </div>
      </section>

      {/* ---- Links + legal ---- */}
      <section className="footer-links">
        <div className="footer-links__ripples" aria-hidden="true" />

        <div className="footer-links__top">
          <a href="/" className="footer-links__logo">
            <img src="/images/doppler.svg" alt="Doppler" />
          </a>

          <div className="footer-links__columns">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.heading} className="footer-links__column">
                <span className="footer-links__column-heading">{col.heading}</span>
                {col.links.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="footer-links__link"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>

        <p className="footer-links__legal">
          The reward structures presented are not financial products and are not registered
          under any securities laws. All yield figures are illustrative and based on
          historical data; actual returns may vary depending on market and protocol
          conditions. Rewards are not guaranteed, and the information presented does not
          constitute financial advice or an offer of financial services. Use of the
          protocol is at your own risk. Please refer to our Docs, including the Terms of
          Service, Privacy Policy, and Disclaimer, for more information.
        </p>
      </section>
    </footer>
  );
}